module.exports = __webpack_public_path__ + "static/56-filedownload-october2037-1c85dc34914b0d0d8afab87c74c785bb.jpg";